import { render, staticRenderFns } from "./LandingInfoItem.vue?vue&type=template&id=03e69a5b&scoped=true"
import script from "./LandingInfoItem.vue?vue&type=script&lang=js"
export * from "./LandingInfoItem.vue?vue&type=script&lang=js"
import style0 from "./LandingInfoItem.vue?vue&type=style&index=0&id=03e69a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e69a5b",
  null
  
)

export default component.exports